__turbopack_context__.v({
  "decorations": "WFus3a_decorations",
  "hideMobile": "WFus3a_hideMobile",
  "preview": "WFus3a_preview",
  "showMobile": "WFus3a_showMobile",
});
